import React from 'react';
import { ContentHeadline } from '../../../_lib/components/ContentHeadline';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { DateRanger } from '../../../components/molecules/DateRanger/DateRanger';
import ILink from '../../../types/ILink';
import { InvisiblyDefinedTerm } from '../../../_lib/components/InvisiblyDefinedTerm';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ICategory } from '../../../types/ICategory';

export type UpcomingEvent = {
  pageLink: ILink;
  eventStartDate: string;
  eventEndDate: string;
  allDayEvent: boolean;
  multiDayEvent: boolean;
  categories?: ICategory[];
  // there are events without owner, e.g. events in free rubrics
  owner?: ILink;
};

export function UpcomingEvent({
  pageLink,
  eventStartDate,
  eventEndDate,
  owner,
  categories,
  allDayEvent = true,
  multiDayEvent = true,
}: UpcomingEvent) {
  const { t } = useSonTranslation('glossary');

  return (
    <article>
      {categories && categories.length > 0
        ? (
            <InvisiblyDefinedTerm
              className="upcoming-event__category font-regular-13-13"
              definition={t(`category${categories.length > 1 ? '_plural' : ''}`)}
            >
              {categories.map(el => el.title).join(', ')}
            </InvisiblyDefinedTerm>
          )
        : null}
      <ContentHeadline url={pageLink.url} title={pageLink.name} />
      <div className="font-bold-14-19">
        <p className="upcoming-event__date-container">
          <DateRanger
            start={eventStartDate}
            end={eventEndDate}
            multiDayEvent={multiDayEvent}
            allDayEvent={allDayEvent}
          />
        </p>
        {owner && (
          <Hyperlink to={owner.url} className="upcoming-event__link">
            {owner.name}
          </Hyperlink>
        )}
      </div>
    </article>
  );
}
